module.exports = __webpack_public_path__ + "98e74e6948182fbff405ce6f62952dee.svg";